export default __webpack_public_path__ + "static/media/1.0d7a6280.jpeg";